import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import HeaderMenu from '../components/header/HeaderMenu'
import NotifierComponent from '../components/notifier/NotifierComponent'
import { intlShape } from 'react-intl'
import '../utils/testMobile'

class MainLayout extends PureComponent {

	render() {
		return (
			<div>
				<HeaderMenu {...this.props} />
				<section className="main-content">
					{this.props.children}
				</section>
				<NotifierComponent />
			</div>
		)
	}
}

MainLayout.propTypes = {
	children: PropTypes.element.isRequired
}

MainLayout.contextTypes = {
	intl: intlShape
}

export default MainLayout



// WEBPACK FOOTER //
// ./src/containers/MainLayout.js